// extracted by mini-css-extract-plugin
export default {"messageContainer":"AlphaReleaseMessage_messageContainer__GUIxB","message":"AlphaReleaseMessage_message__5DelZ"};